// services/connections/contributorService.ts
import { BaseConnectionService } from "./baseConnectionService";
import { ContributorConnection } from "../../types/contributor";

class ContributorConnectionService extends BaseConnectionService<ContributorConnection> {
  constructor() {
    super("contributors");
  }
}

export const contributorConnectionService = new ContributorConnectionService();
